import { Button, Card, Col, PageHeader, Popover, Row, Statistic, Table, Tag, Typography } from 'antd';
import { Provider } from 'jotai';
import React, { useEffect, useState } from 'react';
import { useBeneficiosPage } from './hooks';
import { TipoBeneficio } from 'enums/comunicaciones-cultura/TipoBeneficio';

const BeneficiosPage = () => {
    return (
        <Provider>
            <Navegacion />
            <Card bordered={false}>
                <Estadisticas />
                <ListaBeneficios />
            </Card>
        </Provider>
    );
};

const Estadisticas = () => {

    const { beneficios } = useBeneficiosPage();

    return (
        <Row gutter={16} style={{ marginBottom: "15px" }}>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="Total Solicitudes"
                        value={beneficios.length}
                        valueStyle={{
                            color: '#096dd9',
                        }}

                    />
                </Card>
            </Col>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="Aprobados"
                        value={beneficios.filter(beneficio => beneficio.estado === "APROBADO").length}
                        valueStyle={{
                            color: '#3f8600',
                        }}

                    />
                </Card>
            </Col>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="Pendientes"
                        value={beneficios.filter(beneficio => beneficio.estado === "PENDIENTE").length}
                        valueStyle={{
                            color: '#d48806',
                        }}

                    />
                </Card>
            </Col>
            <Col span={6}>
                <Card>
                    <Statistic
                        title="Rechazados"
                        value={beneficios.filter(beneficio => beneficio.estado === "RECHAZADO").length}
                        valueStyle={{
                            color: '#cf1322',
                        }}

                    />
                </Card>
            </Col>
        </Row>
    )
}

const ListaBeneficios = () => {

    const { beneficios, loading, exportar, fetchBeneficios } = useBeneficiosPage();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        fetchBeneficios();
    }, []);

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const columnas = [
        {
            title: "Colaborador",
            dataIndex: 'colaborador',
            render: (fila) => {
                return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Typography.Text>{fila.nombres} {fila.apellidoPaterno} {fila.apellidoMaterno}</Typography.Text>
                        <Typography.Text type='secondary'>{fila.numeroDocumentoIdentidad}</Typography.Text>
                    </div>
                )
            }
        },
        {
            title: "JefeInmediato",
            dataIndex: 'jefeInmediato',
            render: (fila) => {
                return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Typography.Text>{fila.nombres} {fila.apellidoPaterno} {fila.apellidoMaterno}</Typography.Text>
                        <Typography.Text type='secondary'>{fila.numeroDocumentoIdentidad}</Typography.Text>
                    </div>
                )
            }
        },
        {
            title: "Tipo",
            dataIndex: "tipo",
            render: (tipo) => {
                switch (tipo) {
                    case TipoBeneficio.HORARIO_FLEXIBLE:
                        return <Tag color="cyan">Horario Flexible</Tag>

                    case TipoBeneficio.HORAS_LIBRES:
                        return <Tag color="green">Horas Libres</Tag>

                    case TipoBeneficio.TELETRABAJO:
                        return <Tag color="blue">Teletrabajo</Tag>

                    default:
                        return "";
                }
            }
        },
        {
            title: "Fecha",
            dataIndex: "fecha",
        },
        {
            title: "Hora Inicio",
            dataIndex: "horaInicio",
        },
        {
            title: "Hora Fin",
            dataIndex: "horaFin",
        },
        {
            title: "Estado",
            dataIndex: "estado",
            render: (estado, fila) => {
                if (estado === "PENDIENTE") {
                    return <Tag color='orange'>Pendiente</Tag>
                } else if (estado === "APROBADO") {
                    return <Tag color='green'>Aprobado</Tag>
                } else if (estado === "RECHAZADO") {
                    return (
                        <Popover
                            content={<span>{fila.motivoRechazo}</span>}
                            title="Motivo Rechazo"
                            trigger="click"
                            open={open}
                            onOpenChange={handleOpenChange}
                            placement='bottom'
                        >
                            <Tag color='red' style={{ cursor: 'pointer' }}>Rechazado</Tag>
                        </Popover>
                    )
                }
                return <Tag>{estado}</Tag>
            }
        },
    ];

    return (
        <>
            <Row justify="end" style={{ marginBottom: "15px" }}>
                <Button type='primary' loading={loading} onClick={exportar}>
                    Exportar
                </Button>
            </Row >
            <Table
                rowKey={(beneficio) => beneficio.id}
                dataSource={beneficios}
                columns={columnas}
                size='small'
            />
        </>
    )
}

const Navegacion = () => {
    return (
        <PageHeader
            title="Beneficios"
            breadcrumb={{
                routes: [
                    { breadcrumbName: "Comunicación y Cultura" },
                    { breadcrumbName: 'Beneficios' }
                ],
            }}
            style={{ paddingLeft: "0px" }}
        />
    )
}

export default BeneficiosPage;